var _style, _text, _text2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMmLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1600,
    height: 500,
    viewBox: "0 0 1600 500",
    role: "img",
    "aria-label": "Maturity Assessment Tool",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@800&display=swap');\n    text { \n      font-family: \"Montserrat\", sans-serif; \n      font-weight: 800; \n      fill: #000; \n    }\n  ")), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 185,
    fontSize: 175
  }, "Maturity")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 380,
    fontSize: 175
  }, "Assessment Tool")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMmLogo);
export default __webpack_public_path__ + "static/media/mm_logo.95327372.svg";
export { ForwardRef as ReactComponent };